import type { Ingredient, IngredientCategory } from "@/api/types/drink";

/**
 * Local editable-row representation for the ingredients editor — mirrors
 * the quotes feature's LineItemDraft pattern (string inputs bound to a
 * keyed row array; converted to typed API input only on submit).
 */
export interface IngredientDraft {
  key: string;
  name: string;
  oz: string;
  category: IngredientCategory;
}

let rowCounter = 0;
export function nextIngredientKey(): string {
  rowCounter += 1;
  return `ing-${rowCounter}`;
}

export function emptyIngredientDraft(key: string = nextIngredientKey()): IngredientDraft {
  return { key, name: "", oz: "", category: "spirit" };
}

export function ingredientsToDrafts(ingredients: Ingredient[] | null | undefined): IngredientDraft[] {
  if (!ingredients || ingredients.length === 0) return [];
  return ingredients.map((ing) => ({
    key: nextIngredientKey(),
    name: ing.name,
    oz: String(ing.oz_per_serving),
    category: ing.category,
  }));
}

/** Drops rows with a blank name — an empty trailing row is not sent to the API. */
export function draftsToIngredients(drafts: IngredientDraft[]): Ingredient[] {
  return drafts
    .filter((d) => d.name.trim() !== "")
    .map((d) => ({
      name: d.name.trim(),
      oz_per_serving: Number(d.oz) || 0,
      category: d.category,
    }));
}
